import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const aboutMontessori: BlogMetaData = {
  title: 'モンテッソーリ教育とは？ モンテ歴20年以上のプロがわかりやすく解説！',
  description:
    'GAFAの創業者や棋士の藤井聡太さんなど各分野で活躍されている方々が受けていたことで知られているモンテッソーリ教育。この記事では、そんなモンテッソーリ教育の基本をわかりやすく解説します。',
  thumbnailUrl: '/img/blog-about-montessori-thumbnail.jpg',
  filePath: buildBlogFilePath('about-montessori'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
